var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "container container-small py-5" },
      [
        _vm.tokens != null && _vm.tokens.length > 0
          ? _vm._l(_vm.tokens, function (t) {
              return _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col-auto" }, [
                  _c("div", { staticClass: "form-group mb-0" }, [
                    _c("span", { staticClass: "ml-2 mr-2" }, [
                      t.cardType == "Mastercard"
                        ? _c("img", { attrs: { src: "/media/mastercard.svg" } })
                        : _vm._e(),
                      t.cardType == "Visa"
                        ? _c("img", { attrs: { src: "/media/visa.png" } })
                        : _vm._e(),
                    ]),
                    _vm._v(" " + _vm._s(t.cardNumberMask) + " "),
                  ]),
                ]),
                _c("div", { staticClass: "col-auto" }, [
                  _c(
                    "div",
                    {
                      staticClass: "link d-block",
                      on: {
                        click: function ($event) {
                          return _vm.remove(t.id)
                        },
                      },
                    },
                    [_vm._v("Sterge cardul")]
                  ),
                ]),
              ])
            })
          : _vm.tokens == null || !_vm.tokens.length
          ? _c("div", { staticClass: "text-center" }, [
              _vm._v(" " + _vm._s(_vm.$t("no_saved_credit_card")) + " "),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }